angular.module('bmsApp.settings').controller('SettingsMainCtrl', [
	'$scope',
	'$log',
	'InstanceSvc',
	'FranchiseSvc',
	'AppSettingsSvc',
	function ($scope, $log, InstanceSvc, FranchiseSvc, AppSettingsSvc) {

		function init() {
			self.ecomEnabled = InstanceSvc.instance.ecomEnabled();
			FranchiseSvc.read().then((response) => {
				$scope.franchise = response.data.franchise;
			});
			AppSettingsSvc.index()
				.then(function (response) {
					if (response.data.settings.webex_sms_from_name && response.data.settings.webex_sms_api_key) {
						self.webexEnabled = true;
					}
					else {
						self.webexEnabled = false;
					}
				}, function (errors) {
					self.errors = errors;
				})
				.finally(function () {
				});

		}

		let self = $scope.SettingsMainCtrl = {
			methods: {
				init: init,
			}
		}
	}]);



